export enum BindleResourceType {
  SOFTWARE_APP = "SoftwareApp",
  Lock = "Lock",
  APOLLO = "apollo",
  PIPELINE = "pipeline",
}

export enum BindlePermissionsType {
  CAN_MANAGE = "Can Manage",
  CAN_APPROVE = "can approve",
  UNLOCK = "Unlock",
  EDIT = "Edit",
  CREATE_CHILD = "CreateChild",
  DEPLOY = "Deploy",
}

export enum AuthorizeAPINameSpace {
  BINDLE = "Bindle",
  PIPELINES = "Pipelines",
}

export enum WorkflowStatus {
  COMPLETED = "COMPLETED",
  READY = "READY",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  DRAFT = "DRAFT",
  RUNNING = "RUNNING",
  //TODO: REMOVE AFTER NODE ADDRESS UPDATE WORKFLOW IS MOVED TO SELF SERVE
  SUBMITTED = "SUBMITTED",
  REJECTED = "REJECTED",
}

export enum TaskStatus {
  COMPLETED = "COMPLETED",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  FAILED = "FAILED",
  RUNNING = "RUNNING",
  SCHEDULED = "SCHEDULED",
  OVERRIDEN = "OVERRIDEN",
  SKIPPED = "SKIPPED",
  RE_RUN = "RE_RUN",
  PENDING_REVIEW = "PENDING_REVIEW",
  SCHEDULED_FOR_DEPLOYMENT = "SCHEDULED_FOR_DEPLOYMENT"
}

export enum SubTaskStatus {
  FAILED = "FAILED",
  COMPLETED = "COMPLETED",
  CREATED = "CREATED",
  CREATING = "CREATING",
  RUNNING = "RUNNING",
  PENDING_REVIEW = "PENDING_REVIEW",
  SENDING = "SENDING",
  SCHEDULED_FOR_DEPLOYMENT = "SCHEDULED_FOR_DEPLOYMENT",
  OVERRIDEN = "OVERRIDEN",
  CANCELLED = "CANCELLED"
}

export enum WorkflowDefinitionStatus {
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  DEPRECATED = "DEPRECATED"
}

export enum ApiStatus{
  ERROR='ERROR',
  SUCCESS='SUCCESS'
}
